"use client";

import { Fragment, useState } from "react";
import { CaretSortIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/atoms/Button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/atoms/Drawer";
import { NavigationList } from "@/components/organisms/NavigationBar/index";
import type { IMobileNavigationBarProps } from "@/components/organisms/NavigationBar/types";
import { useMediaQuery } from "@/hooks/common/useMediaQuery";
import { useTranslations } from "@/hooks/common/useTranslations";

import { SCREEN_SIZES } from "@/common/globalTypes/enums/common";

const MobileNavigation = ({
  menu,
  selectedMenuItemValue,
}: IMobileNavigationBarProps) => {
  const { t } = useTranslations("common");
  const isMobile = useMediaQuery(SCREEN_SIZES.md);
  const [open, setOpen] = useState(false);

  return (
    <Fragment key="navigation">
      {isMobile && (
        <div>
          <Drawer open={open} onOpenChange={setOpen}>
            <DrawerTrigger asChild>
              <Button variant="ghost" size="icon">
                <CaretSortIcon
                  className="opacity-100"
                  style={{ width: "24px", height: "24px" }}
                />
              </Button>
            </DrawerTrigger>
            <DrawerContent className="mb-6">
              <DrawerHeader>
                <DrawerTitle>{t("category")}</DrawerTitle>
              </DrawerHeader>
              <NavigationList
                list={menu}
                selectedMenuItemValue={selectedMenuItemValue}
              />
            </DrawerContent>
          </Drawer>
        </div>
      )}
    </Fragment>
  );
};

export default MobileNavigation;
